import { findingAttackToDisplayName } from 'src/app/common/findingRulesUtils';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export const GenAiMatrixSelectOptionsAll: ISelectOption = {
  id: `${FilterTypesEnum.GenAiMatrix.toString()}-all`,
  value: 'all',
  displayName: 'All',
  filterType: FilterTypesEnum.GenAiMatrix,
  categoryName: FilterTypesEnum.GenAiMatrix.toString(),
};

export const GenAiMatrixSelectOptions: ISelectOption[] = Object.keys(findingAttackToDisplayName).map(
  (attackKey) =>
    ({
      id: `${FilterTypesEnum.GenAiMatrix.toString()}-${attackKey}`,
      value: attackKey,
      displayName: findingAttackToDisplayName[attackKey],
      filterType: FilterTypesEnum.GenAiMatrix,
      categoryName: FilterTypesEnum.GenAiMatrix.toString(),
    }) as ISelectOption
);
